module.exports = __webpack_public_path__ + "static/media/onboarding8mobile.ab0802d9.svg";